namespace SP {

    export interface ShipmentLineInfo {
        id: string;
        qty: number;
        orderLine: OrderLineInfo;
        returnInfo: ReturnInfo;
        data: ShipmentLineData[];
    }
}